import React from "react";

const Loading = () => (
  <>Loading...</>
);

export default Loading;